const BannerWrapper = ({ isMobileView, children }) => {
	if (isMobileView) {
		return (
			<div className="syndicated-container__mobile-wrapper">{children}</div>
		);
	}
	return children;
};

export default BannerWrapper;
